/* global form:true */

/**
 * Form Object: This is the base object for proposal and approvalProcess form.
 * It is currently in use for admin/process.
 * All random IDs are generated using the Unique Random Number Script, unique.js.
 * All DOM Ids are in the format: type-#####(-fieldlabel)?(-index)?
 * All Names are in the format: type[#####][fieldlabel]?[index]?
 */

form = function(id) {
	'use strict';

	var objForm = {};


	/*
	 * Function getfieldName (private)
	 * Purpose: to extract the field's id from the DOM id to insert into the NAME attribute of a field.
	 * getfieldName takes as an argument either:
	 * 1) An empty argument
	 * 2) The Name format field[#####]
	 * 3) The DOMId format field-#####
	 */

	var getFieldName = function(fieldId) {
		var fieldName = '';
		if ((fieldId !== '') && (fieldId !== null)) {
			var field = fieldId.match(/field[\\[\-](\d*)(\\])?/);
			if (field !== null) {
				fieldName = 'field['+field[1]+']';
			}
		} else {
			fieldName = 'field['+ myUniquer.create() +']';
		}
		return fieldName;
	};

	/*
	 * Function getFieldDOMId (private)
	 * Purpose: to extract the fieldset's id to apply to all DOM Ids.
	 */

	var getFieldDOMId = function(fieldsetId) {
		var FieldDOMId = fieldsetId.replace('fieldset','field');
		return FieldDOMId;
	};

	return objForm;

};
